module.exports = __webpack_public_path__ + "img/estimateSolidIcon.e77b9f96.svg";